module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_7.ac700df6.jpg";